module.exports = __webpack_public_path__ + "media/images/icons/outlined/font-colors-2563b1e1d7a451e43e923092b8b57b94.svg";